<template lang="pug">
.smm(:class="{active: s> 100}")
  .smmBlock(@click="push=!push" )
    .smmLine1(:class="{active: push==true}")
    .smmLine2(:class="{active: push==true}")


</template>

<script>
export default {
  // props: {
  //   sideMenuOpen: {
  //     type: Boolean,
  //     defalt: false
  //   }
  // },
  data() {
    return {
      s: '',
      push: false,
    }
  },
  watch: {
    '$route'(to,from){
      this.push=false
    }
  },
  mounted() {
    window.addEventListener('scroll', this.scroll);
  },
  methods:{
    scroll() {
      this.s = window.scrollY || window.pageYOffset || document.documentElement.scrollTop
    }
  },
}
</script>

<style lang="sass">
@import '@/assets/style.sass'
.smm
  position: fixed
  z-index: 22
  width: 40px
  height: 50px
  // box-sizing: border-box
  // +bb
  top: 40px
  left: 5px
  // background-color: #878787
  display: none
  cursor: pointer
  // z-index: 99
  +pad
    display: block
  //捲下來後
  &.active
    top: 40px


  .smmBlock
    width: 100%
    height: 100%
    .smmLine1
      position: relative
      width: 30px
      height: 3px
      background-color: #333
      // margin-top: 35%
      margin-left: 15%
      transform-origin: 30% 130%
      opacity: 1
      transition: 0.3s
      &.active
        transition: 0.3s
        opacity: 0
        // transform: rotate(45deg)
    .smmLine2
      position: relative
      width: 30px
      height: 3px
      background-color: #333
      margin-top: 5px
      margin-left: 15%
      transform-origin: 28% -20%
      transition: 0.3s
      opacity: 1


      &.active
        transition: 0.3s
        opacity: 0
        // transform: rotate(-45deg)
</style>


// WEBPACK FOOTER //
// src/components/SmallMenu.vue